module.exports = __webpack_public_path__ + "static/media/roller06.827673d9.png";